import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import Logo from './Logo';
import '../styles/Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isAuthenticated } = useAuthStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isEnglish = i18n.resolvedLanguage?.startsWith('en');

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.search]);

  const toggleLanguage = () => {
    i18n.changeLanguage(isEnglish ? 'fr' : 'en');
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
    navigate('/');
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="logo" onClick={closeMenu}>
            <Logo />
          </Link>

          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            ☰
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li>
              <Link to="/" className="nav-link" onClick={closeMenu}>
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link to="/services" className="nav-link" onClick={closeMenu}>
                {t('nav.services')}
              </Link>
            </li>
            {isAuthenticated && user?.role === 'admin' && (
              <li>
                <Link to="/admin" className="nav-link" onClick={closeMenu}>
                  {t('nav.admin')}
                </Link>
              </li>
            )}
            {isAuthenticated && user?.role === 'collaborator' && (
              <li><Link to="/availability" className="nav-link" onClick={closeMenu}>{t('nav.availability')}</Link></li>
            )}

            {isAuthenticated && (
              <li>
                <Link to="/my-bookings" className="nav-link" onClick={closeMenu}>
                  {t('nav.myBookings')}
                </Link>
              </li>
            )}

            {isAuthenticated && (
              <li>
                <Link to="/profile" className="nav-link" onClick={closeMenu}>
                  {t('nav.profile')}
                </Link>
              </li>
            )}

            {isAuthenticated && (
              <li>
                <span className="nav-user">{user?.name}</span>
              </li>
            )}

            <li>
              <button className="lang-toggle" onClick={toggleLanguage}>
                {isEnglish ? 'FR' : 'EN'}
              </button>
            </li>

            {isAuthenticated ? (
              <li>
                <button className="auth-btn logout-btn" onClick={handleLogout}>
                  {t('nav.logout')}
                </button>
              </li>
            ) : (
              <li>
                <Link to="/login" className="auth-btn login-btn" onClick={closeMenu}>
                  {t('nav.login')}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
